"use strict";
import "src/decidim/forms/forms";
import "stylesheets/decidim/forms/forms.scss";
import "stylesheets/decidim/forms/questionnaire-answers-pdf.scss";
require.context("../images", true);
